import * as React from "react";
const SvgArrowDownSmall20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 7,
        fill: "black",
        viewBox: "0 0 10 7"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m2 .586 3 3 3-3L9.414 2 5 6.414.586 2 2 .586Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowDownSmall20Px;
